<script setup lang="ts">
  import type { Component } from 'vue';
  import { permissionFooterButtonClass } from './directoriesPermissions.styles';

  defineProps<{
    text: string;
    icon: Component;
    disabled?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'click'): void;
  }>();
</script>

<template>
  <button
    type="button"
    :class="permissionFooterButtonClass"
    :disabled="disabled"
    @click="emit('click')"
  >
    <component
      :is="icon"
      class="size-4 shrink-0 text-white"
      aria-hidden="true"
    />
    <span>{{ text }}</span>
  </button>
</template>
